var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInternationalAid = function SvgInternationalAid(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34791_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4402 3.34564L13.7858 7.00001L7.90156 4.19799C6.9133 3.72739 5.74306 3.86277 4.88833 4.54654L3.53501 5.62919C3.14127 5.94419 3.18903 6.55697 3.62683 6.80714L10.2144 10.5714L7.35721 13.4286L5.30343 13.1126C3.94208 12.9032 2.71436 13.9565 2.71436 15.3338C2.71436 15.8831 3.11148 16.3519 3.6533 16.4422L7.00007 17L7.55787 20.3467C7.64817 20.8886 8.11696 21.2857 8.66626 21.2857C10.0436 21.2857 11.0969 20.058 10.8875 18.6966L10.5715 16.6429L13.4286 13.7857L17.1929 20.3733C17.4431 20.811 18.0559 20.8589 18.3709 20.465L19.4535 19.1117C20.1374 18.257 20.2726 17.0867 19.8021 16.0985L17.0001 10.2143L20.6545 6.55992C21.0586 6.15568 21.2858 5.60741 21.2858 5.03572C21.2858 4.46404 21.0586 3.91577 20.6545 3.51152L20.4885 3.34564C20.0844 2.9414 19.5361 2.71429 18.9644 2.71429C18.3926 2.71429 17.8444 2.9414 17.4402 3.34564Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34791_3600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInternationalAid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "international-aid.ccf0a387d7666f84b17154e671b5f5fe.svg";